<div class="rebranded-audio-container" *ngIf="src" (click)="$event.stopPropagation();"
     [ngClass]='{ "bg-white": imageUrl, "tw-rounded-full tw-px-2 tw-py-[3px] tw-h-[48px]": newUI}'>
  <div class="audio-img-container" [ngClass]='{ "tw-w-[42px] tw-h-[42px]": newUI}' *ngIf="imageUrl">
    <img alt="doctor profile photo" class="audio-img" [ngClass]='{ "tw-w-[42px] tw-h-[42px] tw-mx-0": newUI, "mL5 mR5": !newUI}' src="{{imageUrl}}" />
    <img *ngIf="!newUI" alt="green mic" class="audio-mic" src="/assets/images/mic.svg" />
    <img *ngIf="newUI" alt="orange mic" class="tw-absolute tw-left-[40px] tw-bottom-[14px]" src="/assets/icons/orange-mic.svg"/>
  </div>
  <div class="slider-box" [ngClass]='{ "mL20": imageUrl && !newUI, "tw-bg-transparent tw-ml-2": newUI}'>
  <div class="text-center play-container" *ngIf="!isPlaying" (click)="playAudio();$event.stopPropagation();">
    <em class="cs-icon-play playButton"></em>
  </div>
  <div class="text-center play-container" *ngIf="isPlaying" (click)="pauseAudio();$event.stopPropagation();">
    <em class="cs-icon-pause pauseButton"></em>
  </div>
  <div class="slider-container">
    <input class="slider" #slider="" type="range" min="0" max="100" value="0" step="1" />
    <div class="slider-time">
    <loading *ngIf="loading" [scale]="0.4" margin="-11px"></loading>
    <div class="font12" *ngIf="!loading">{{audioDuration}}</div>
    </div>
  </div>
  <div class="speed-control" *ngIf="internalUser" (click)="togglePlaybackSpeed();$event.stopPropagation();" title="Playback Speed">
    <span class="speed-button">{{playbackSpeed}}x</span>
  </div>
  </div>
</div>